import { render, staticRenderFns } from "./HruserShimmer.vue?vue&type=template&id=0d77e1f2&"
import script from "./HruserShimmer.vue?vue&type=script&lang=js&"
export * from "./HruserShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports